import { requestJson } from './http';

export function getUsers() {
  return requestJson('/api/users');
}

export function createUser(fields) {
  return requestJson('/api/users/create', {
    method: 'POST',
    body: JSON.stringify(fields)
  });
}

export function updateUser(recordId, fields) {
  return requestJson(`/api/users/${encodeURIComponent(recordId)}`, {
    method: 'PATCH',
    body: JSON.stringify(fields)
  });
}
